import { Icon } from "@majourneys/icons";
import { STAYS_EASE } from "../lib/motion";

/**
 * A mood chip's icon, which turns into a tick when the mood is on.
 *
 * Both glyphs share one fixed box and cross over by scale and opacity, so the
 * chip never changes width as it is toggled: a width change would shove the
 * chips beside it along the row on every tap.
 */
export function MoodGlyph({ icon, on, size }: { icon: string; on: boolean; size: number }) {
  const swap = `opacity 160ms ${STAYS_EASE}, transform 200ms ${STAYS_EASE}`;
  return (
    <span aria-hidden="true" className="relative inline-block shrink-0" style={{ width: size, height: size }}>
      <Icon
        name={icon}
        className="absolute inset-0 motion-reduce:transition-none"
        style={{ fontSize: size, opacity: on ? 0 : 1, transform: on ? "scale(0.6)" : "none", transition: swap }}
      />
      <Icon
        name="ri-check-line"
        className="absolute inset-0 motion-reduce:transition-none"
        style={{ fontSize: size, opacity: on ? 1 : 0, transform: on ? "none" : "scale(0.6)", transition: swap }}
      />
    </span>
  );
}
